export enum ProjectType {
  Invalid = 0,

  // TODO: to completely define this list with client
  Carport,
  Busport,
  Combined,
}
